'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var innerSlider = {};

exports.__exports = innerSlider;
